// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4a2522cc] .lx-card > div.guest-verification-success-card-header{background-color:#28a745 !important;border-color:#28a745 !important}[data-v-4a2522cc] .lx-card > div.guest-verification-reject-card-header{background-color:#cf5329 !important;border-color:#cf5329 !important}.errors-wrapper[data-v-4a2522cc]{gap:20px}", ""]);
// Exports
module.exports = exports;
